import React from 'react';

import School from '../../../types/School';
import Teacher from '../../../types/Teacher';

import Table from '../../common/ui/Table/Table';
import TableHead from '../../common/ui/Table/Head';
import TeachersTableRow from './TableRow';

interface Props {
  teachers: Teacher[];
  schools: Record<number, School>;
  unauthorizedCallback: () => void;
  showError: (text: string) => void;

  sortData: { column: string; descending: boolean };
  setSortData: (data: { column: string; descending: boolean }) => void;
}

const TeachersTable = ({
  teachers,
  schools,
  unauthorizedCallback,
  showError,
  sortData,
  setSortData,
}: Props) => {
  const teachersRows = teachers.map((teacher: Teacher) => (
    <TeachersTableRow
      key={teacher.id}
      teacher={teacher}
      schools={schools}
      unauthorizedCallback={unauthorizedCallback}
      showError={showError}
    />
  ));

  return (
    <Table>
      <TableHead
        columns={[
          { label: 'Имя пользователя', width: '50%' },
          { label: 'Школа', width: '50%' },
        ]}
        sortingBy={sortData.column}
        descending={sortData.descending}
        setSortData={setSortData}
      />

      <tbody>{teachersRows}</tbody>
    </Table>
  );
};

export default TeachersTable;
